import { FC } from 'react';
import { BrightTooltip } from 'components/tooltips/BrightTooltip.tsx';

import styles from './RoleIconMultiple.module.scss';
import { ProjectRoleDto } from 'services/api/api-client.types.ts';

export type RoleIconMultipleProps = {
  roles: ProjectRoleDto[];
};

export const RoleIconMultiple: FC<RoleIconMultipleProps> = (
  props: RoleIconMultipleProps,
) => {
  return (
    <BrightTooltip
      key={props.roles.length}
      title={<RoleMultipleTooltip roles={props.roles} />}
      placement="bottom"
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      }}
    >
      <div className={styles.icon}>+{props.roles.length}</div>
    </BrightTooltip>
  );
};

type RoleMultipleTooltipProps = {
  roles: ProjectRoleDto[];
};

const RoleMultipleTooltip: FC<RoleMultipleTooltipProps> = (props) => {
  return (
    <div className={styles.tooltip}>
      {props.roles.map((role) => (
        <RoleMultipleTooltipChunk dto={role} />
      ))}
    </div>
  );
};

type RoleMultipleTooltipChunkProps = {
  dto: ProjectRoleDto;
};

const RoleMultipleTooltipChunk: FC<RoleMultipleTooltipChunkProps> = (props) => {
  return (
    <>
      <div className={styles.tooltipTitle}>{props.dto.name}</div>
      <div className={styles.tooltipItems}>
        {props.dto.signers?.map((e) => (
          <div className={styles.tooltipItem}>
            {e.signer.firstName} {e.signer.lastName}
          </div>
        ))}
      </div>
    </>
  );
};
